import * as Scrivito from "scrivito"

export const BenefitItemWidget = Scrivito.provideWidgetClass(
  "BenefitItemWidget",
  {
    attributes: {
      featureLabel: ["widgetlist", { only: ["TextWidget"] }],
      icons: ["widgetlist", { only: ["BenefitIconWidget"] }]
    }
  }
)
